import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingBag, Wallet, User } from 'lucide-react';
import { motion } from 'framer-motion';
export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = [{
    path: '/',
    icon: LayoutDashboard,
    label: 'Dashboard'
  }, {
    path: '/products',
    icon: Package,
    label: 'Products'
  }, {
    path: '/orders',
    icon: ShoppingBag,
    label: 'Orders'
  }, {
    path: '/wallet',
    icon: Wallet,
    label: 'Wallet'
  }, {
    path: '/profile',
    icon: User,
    label: 'Profile'
  }];
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };
  return <nav className="fixed bottom-0 left-0 right-0 bg-[#0A0E1A]/80 backdrop-blur-2xl border-t border-white/[0.06] z-50 pb-safe" data-id="element-26">
      <div className="max-w-md mx-auto flex justify-around items-center h-20 px-2" data-id="element-27">
        {navItems.map(item => {
        const Icon = item.icon;
        const active = isActive(item.path);
        return <button key={item.path} onClick={() => navigate(item.path)} className="flex flex-col items-center justify-center flex-1 h-full relative group" data-id="element-28">
              <Icon className={`w-6 h-6 mb-1.5 transition-colors ${active ? 'text-[#00D68F]' : 'text-[#475569] group-hover:text-[#64748B]'}`} data-id="element-29" />
              <span className={`text-[10px] font-medium tracking-wide transition-colors ${active ? 'text-[#00D68F]' : 'text-[#475569] group-hover:text-[#64748B]'}`} data-id="element-30">
                {item.label}
              </span>
              {active && <motion.div layoutId="activeNavDot" className="absolute bottom-2 w-1 h-1 bg-[#00D68F] rounded-full shadow-[0_0_8px_rgba(0,214,143,0.8)]" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-31" />}
            </button>;
      })}
      </div>
    </nav>;
}